<template>
    <div class="animated fadeIn">
        <BasicHeading title="Select Previous Schedule"></BasicHeading>
        <schedule-server-table-fillable
            :filter_day="previous_week"
            :schedule_id="schedule_id"
            :schedule_type="schedule_type"
            collection_status="Approved"
            @rowClicked="handleSelect"
        />
    </div>
</template>

<script>
import BasicHeading from '@/components/shared/BasicHeading';
import ScheduleServerTableFillable from '@/components/lab/schedule/ScheduleServerTableFillable';
import { LabRepositoryFactory } from '@/repositories/lab/LabRepositoryFactory';
import moment from 'moment';

const ScheduleRepository = LabRepositoryFactory.get("schedule");

export default {
    name: "PreviousSchedule",
    components: {
        BasicHeading,
        ScheduleServerTableFillable
    },
    data() {
        return {
            current_day: moment().format('YYYY-MM-DD'),
            schedules: null,
            schedule_type: null,
            days_back: 7,
            schedule_id: null,
        }
    },
    computed: {
        previous_week() {
            return moment(this.current_day).subtract(this.days_back, 'days').format('YYYY-MM-DD');
        }
    },
    methods: {
        async handleSelect(id) {
            await ScheduleRepository.copySchedule(this.schedule_id, id)
        },
        async init() {
            await this.getCurrentScheduleSampleType();
        },
        async getCurrentScheduleSampleType() {
            const current_schedule = await ScheduleRepository.get(this.schedule_id);
            this.schedule_type = current_schedule.data.sample_type_id;
        },
    },
    mounted() {
        this.schedule_id = this.$route.params.schedule_id;
        this.init();
    }
}
</script>